//TODO : Refactor after ai
// Generiert von scripts/viacid-demo-data.py – nicht von Hand ändern.
// Quelle: Notion „Viacid Analyse“ → Datenmodell, Stand Review 12.10.2026.

import type { ObjektKlasse, Relation, Rolle } from "./types";

export const OBJEKTKLASSEN: ObjektKlasse[] = [
  {
    slug: "kunde",
    name: "Kunde",
    plural: "Kunden",
    art: "Stammdaten",
    prioritaet: 10,
    navigation: "stammdaten",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Kommune, Unternehmen oder Händler, für den Viacid Leistungen erbringt oder Baustoffe liefert.",
    kennungFeld: "kundennummer",
    felder: [
      {
        key: "kundennummer",
        label: "Kundennummer",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "name",
        label: "Name",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "kundengruppe",
        label: "Kundengruppe",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "adresse",
        label: "Adresse",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "eMailRechnungsversand",
        label: "E-Mail Rechnungsversand",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "zahlungsziel",
        label: "Zahlungsziel",
        typ: "Ganzzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "baustoffbezug",
        label: "Baustoffbezug",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bexioID",
        label: "Bexio-ID",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Verkaufsberater zuordnen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: [],
        rollen: ["LV"],
        relation: "kunde-wird-betreut-von-mitarbeiter",
        prioritaet: 30,
      },
    ],
  },
  {
    slug: "mitarbeiter",
    name: "Mitarbeiter",
    plural: "Mitarbeitende",
    art: "Stammdaten",
    prioritaet: 20,
    navigation: "stammdaten",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Mitarbeitende von Viacid in Innendienst, Vertrieb, Disposition, Ausführung und Produktion.",
    kennungFeld: "personalnummer",
    felder: [
      {
        key: "name",
        label: "Name",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "personalnummer",
        label: "Personalnummer",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "funktion",
        label: "Funktion",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "qualifikationen",
        label: "Qualifikationen",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: true,
      },
      {
        key: "telefon",
        label: "Telefon",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "stundenkostensatz",
        label: "Stundenkostensatz",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [],
  },
  {
    slug: "strassenobjekt",
    name: "Straßenobjekt",
    plural: "Straßenobjekte",
    art: "Stammdaten",
    prioritaet: 30,
    navigation: "stammdaten",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Straße, Platz oder Abschnitt, an dem Leistungen erbracht werden.",
    kennungFeld: null,
    felder: [
      {
        key: "objektbezeichnung",
        label: "Objektbezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "adresse",
        label: "Adresse",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "koordinaten",
        label: "Koordinaten",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "belagsart",
        label: "Belagsart",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "zufahrtshinweise",
        label: "Zufahrtshinweise",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Straßenobjekt anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Straßenobjekt ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["VB"],
        relation: null,
        prioritaet: 20,
      },
    ],
  },
  {
    slug: "baustellenaufnahme",
    name: "Baustellenaufnahme",
    plural: "Baustellenaufnahmen",
    art: "Vorgang",
    prioritaet: 40,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: true,
    beschreibung:
      "Vor-Ort-Aufnahme eines Straßenobjekts mit Maßen und Vorausmaß.",
    kennungFeld: null,
    felder: [
      {
        key: "aufnahmedatum",
        label: "Aufnahmedatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "abschnitt",
        label: "Abschnitt",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "gemesseneLaenge",
        label: "Gemessene Länge",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "gemesseneBreite",
        label: "Gemessene Breite",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "vorausmass",
        label: "Vorausmaß",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bemerkungen",
        label: "Bemerkungen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bewertetAm",
        label: "Bewertet am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["In Aufnahme", "Aufgenommen", "Bewertet"],
    actions: [
      {
        name: "Baustellenaufnahme anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "In Aufnahme",
        erlaubt: [],
        rollen: ["VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Aufnahme abschließen",
        operation: "Setzen",
        art: "Status",
        ziel: "Aufgenommen",
        erlaubt: ["In Aufnahme"],
        rollen: ["VB"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Aufnahme bewerten",
        operation: "Setzen",
        art: "Status",
        ziel: "Bewertet",
        erlaubt: ["Aufgenommen"],
        rollen: ["VB"],
        relation: null,
        prioritaet: 60,
      },
    ],
  },
  {
    slug: "schadstelle",
    name: "Schadstelle",
    plural: "Schadstellen",
    art: "Vorgang",
    prioritaet: 50,
    navigation: "vorgaenge",
    inNavigation: false,
    mobil: true,
    beschreibung: "Einzelner Schaden innerhalb einer Baustellenaufnahme.",
    kennungFeld: null,
    felder: [
      {
        key: "position",
        label: "Position",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "schadensart",
        label: "Schadensart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "schadensmenge",
        label: "Schadensmenge",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "mengeneinheit",
        label: "Mengeneinheit",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "schweregrad",
        label: "Schweregrad",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "beschreibung",
        label: "Beschreibung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "geschaetzteMaterialmenge",
        label: "Geschätzte Materialmenge",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Schadstelle erfassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Schadstelle ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["VB"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Maßnahmenart zuordnen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: [],
        rollen: ["VB"],
        relation: "schadstelle-erfordert-massnahmenart",
        prioritaet: 30,
      },
      {
        name: "Material empfehlen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: [],
        rollen: ["VB"],
        relation: "schadstelle-empfiehlt-artikel",
        prioritaet: 30,
      },
    ],
  },
  {
    slug: "baustellenfoto",
    name: "Baustellenfoto",
    plural: "Baustellenfotos",
    art: "Dokument / Datei",
    prioritaet: 60,
    navigation: "dokumente",
    inNavigation: true,
    mobil: true,
    beschreibung:
      "Foto als Nachweis zu Aufnahme, Ausführung, Ausmaß oder Reklamation.",
    kennungFeld: null,
    felder: [
      {
        key: "datei",
        label: "Datei",
        typ: "Datei",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "fotoart",
        label: "Fotoart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "aufnahmezeitpunkt",
        label: "Aufnahmezeitpunkt",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "koordinaten",
        label: "Koordinaten",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "beschreibung",
        label: "Beschreibung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Baustellenfoto hinzufügen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["GF", "KO", "VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Baustellenfoto zuordnen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: [],
        rollen: ["GF"],
        relation: "baustellenfoto-dokumentiert-einsatz",
        prioritaet: 30,
      },
    ],
  },
  {
    slug: "massnahmenart",
    name: "Maßnahmenart",
    plural: "Maßnahmenarten",
    art: "Katalog & Konfiguration",
    prioritaet: 70,
    navigation: "stammdaten",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Standardleistung im Straßenunterhalt mit Ansätzen, Leistungswerten und Richtpreis.",
    kennungFeld: null,
    felder: [
      {
        key: "bezeichnung",
        label: "Bezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "beschreibung",
        label: "Beschreibung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "abrechnungseinheit",
        label: "Abrechnungseinheit",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "saisonfenster",
        label: "Saisonfenster",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: true,
      },
      {
        key: "einheitspreis",
        label: "Einheitspreis",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bindemittelansatz",
        label: "Bindemittelansatz",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "splittansatz",
        label: "Splittansatz",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "leistungJeStunde",
        label: "Leistung je Stunde",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "teamgroesse",
        label: "Teamgröße",
        typ: "Ganzzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "mindesttemperaturBoden",
        label: "Mindesttemperatur Boden",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "ausfuehrungsbedingungen",
        label: "Ausführungsbedingungen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [],
  },
  {
    slug: "artikel",
    name: "Artikel",
    plural: "Artikel",
    art: "Katalog & Konfiguration",
    prioritaet: 80,
    navigation: "stammdaten",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Baustoff aus dem Sortiment (Bindemittel, Splitt, Kaltmischgut usw.) für Handel und Eigenverbrauch.",
    kennungFeld: "artikelnummer",
    felder: [
      {
        key: "artikelnummer",
        label: "Artikelnummer",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bezeichnung",
        label: "Bezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "artikelgruppe",
        label: "Artikelgruppe",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "gebindeeinheit",
        label: "Gebindeeinheit",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "gebindegroesse",
        label: "Gebindegröße",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "mengeneinheit",
        label: "Mengeneinheit",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "verkaufspreis",
        label: "Verkaufspreis",
        typ: "Dezimalzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einstandspreis",
        label: "Einstandspreis",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "technischeAngaben",
        label: "Technische Angaben",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "anwendungshinweise",
        label: "Anwendungshinweise",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "preisGueltigAb",
        label: "Preis gültig ab",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Aktiv", "Ausgelistet"],
    actions: [
      {
        name: "Artikel anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Aktiv",
        erlaubt: [],
        rollen: ["ID"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Artikel ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Aktiv"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Artikel auslisten",
        operation: "Setzen",
        art: "Status",
        ziel: "Ausgelistet",
        erlaubt: ["Aktiv"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 50,
      },
    ],
  },
  {
    slug: "kalkulation",
    name: "Kalkulation",
    plural: "Kalkulationen",
    art: "Vorgang",
    prioritaet: 90,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Mengen-, Ressourcen- und Preisermittlung für eine Maßnahme; Grundlage für Angebot und Ausführung.",
    kennungFeld: null,
    felder: [
      {
        key: "kalkulationsdatum",
        label: "Kalkulationsdatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "version",
        label: "Version",
        typ: "Ganzzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "kalkulierteFlaeche",
        label: "Kalkulierte Fläche",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bindemittelansatz",
        label: "Bindemittelansatz",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "splittansatz",
        label: "Splittansatz",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "anzahlMitarbeitende",
        label: "Anzahl Mitarbeitende",
        typ: "Ganzzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "benoetigteFahrzeugarten",
        label: "Benötigte Fahrzeugarten",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: true,
      },
      {
        key: "ausfuehrungsdauer",
        label: "Ausführungsdauer",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "kalkulierterPreis",
        label: "Kalkulierter Preis",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "annahmen",
        label: "Annahmen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "freigegebenAm",
        label: "Freigegeben am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Entwurf", "Freigegeben", "Überholt"],
    actions: [
      {
        name: "Kalkulation anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Entwurf",
        erlaubt: [],
        rollen: ["VB", "DI"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Kalkulation ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Entwurf"],
        rollen: ["VB", "DI"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Kalkulation freigeben",
        operation: "Setzen",
        art: "Status",
        ziel: "Freigegeben",
        erlaubt: ["Entwurf"],
        rollen: ["DI"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Kalkulation ersetzen",
        operation: "Setzen",
        art: "Status",
        ziel: "Überholt",
        erlaubt: ["Entwurf", "Freigegeben"],
        rollen: ["DI"],
        relation: null,
        prioritaet: 60,
      },
    ],
  },
  {
    slug: "kalkulationsposition",
    name: "Kalkulationsposition",
    plural: "Kalkulationspositionen",
    art: "Vorgang",
    prioritaet: 100,
    navigation: "vorgaenge",
    inNavigation: false,
    mobil: false,
    beschreibung:
      "Einzelner Material-, Personal-, Fahrzeug- oder Maschinenbedarf einer Kalkulation.",
    kennungFeld: null,
    felder: [
      {
        key: "positionsart",
        label: "Positionsart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bezeichnung",
        label: "Bezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "menge",
        label: "Menge",
        typ: "Dezimalzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einheit",
        label: "Einheit",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "kostensatz",
        label: "Kostensatz",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Kalkulationsposition erfassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["VB", "DI"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Kalkulationsposition ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["VB", "DI"],
        relation: null,
        prioritaet: 20,
      },
    ],
  },
  {
    slug: "angebot",
    name: "Angebot",
    plural: "Angebote",
    art: "Beleg",
    prioritaet: 110,
    navigation: "dokumente",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Angebot oder Auftragsbestätigung an einen Kunden, in Versionen.",
    kennungFeld: "angebotsnummer",
    felder: [
      {
        key: "angebotsnummer",
        label: "Angebotsnummer",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "dokumentart",
        label: "Dokumentart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "angebotsdatum",
        label: "Angebotsdatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "gueltigBis",
        label: "Gültig bis",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "version",
        label: "Version",
        typ: "Ganzzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "leistungsbeschreibung",
        label: "Leistungsbeschreibung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "kalkulationsannahmen",
        label: "Kalkulationsannahmen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "aenderungswunsch",
        label: "Änderungswunsch",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "ablehnungsgrund",
        label: "Ablehnungsgrund",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "versendetAm",
        label: "Versendet am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "entschiedenAm",
        label: "Entschieden am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [
      "In Erstellung",
      "Versendet",
      "Änderung gewünscht",
      "Angenommen",
      "Abgelehnt",
    ],
    actions: [
      {
        name: "Angebot anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "In Erstellung",
        erlaubt: [],
        rollen: ["ID", "VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Angebot ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["In Erstellung", "Versendet", "Änderung gewünscht"],
        rollen: ["ID", "VB"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Angebot versenden",
        operation: "Senden",
        art: "Status",
        ziel: "Versendet",
        erlaubt: ["In Erstellung", "Änderung gewünscht"],
        rollen: ["ID", "VB"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Änderung wünschen",
        operation: "Setzen",
        art: "Status",
        ziel: "Änderung gewünscht",
        erlaubt: ["Versendet"],
        rollen: ["HA", "KO", "VB"],
        relation: null,
        prioritaet: 60,
      },
      {
        name: "Angebot annehmen",
        operation: "Setzen",
        art: "Status",
        ziel: "Angenommen",
        erlaubt: ["Versendet"],
        rollen: ["HA", "KO"],
        relation: null,
        prioritaet: 70,
      },
      {
        name: "Angebot ablehnen",
        operation: "Setzen",
        art: "Status",
        ziel: "Abgelehnt",
        erlaubt: ["Versendet", "Änderung gewünscht"],
        rollen: ["HA", "KO"],
        relation: null,
        prioritaet: 80,
      },
    ],
  },
  {
    slug: "angebotsposition",
    name: "Angebotsposition",
    plural: "Angebotspositionen",
    art: "Beleg",
    prioritaet: 120,
    navigation: "dokumente",
    inNavigation: false,
    mobil: false,
    beschreibung: "Position eines Angebots mit Menge und Preis.",
    kennungFeld: null,
    felder: [
      {
        key: "positionsnummer",
        label: "Positionsnummer",
        typ: "Ganzzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bezeichnung",
        label: "Bezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "menge",
        label: "Menge",
        typ: "Dezimalzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einheit",
        label: "Einheit",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einzelpreis",
        label: "Einzelpreis",
        typ: "Dezimalzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "rabatt",
        label: "Rabatt",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Angebotsposition erfassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["ID", "VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Angebotsposition ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["ID", "VB"],
        relation: null,
        prioritaet: 20,
      },
    ],
  },
  {
    slug: "ansprechpartner",
    name: "Ansprechpartner",
    plural: "Ansprechpartner",
    art: "Stammdaten",
    prioritaet: 130,
    navigation: "stammdaten",
    inNavigation: true,
    mobil: false,
    beschreibung: "Person beim Kunden, mit der Viacid kommuniziert.",
    kennungFeld: null,
    felder: [
      {
        key: "name",
        label: "Name",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "funktion",
        label: "Funktion",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "telefon",
        label: "Telefon",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "eMail",
        label: "E-Mail",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Ansprechpartner anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["ID", "VB"],
        relation: null,
        prioritaet: 10,
      },
    ],
  },
  {
    slug: "verkaufschance",
    name: "Verkaufschance",
    plural: "Verkaufschancen",
    art: "Vorgang",
    prioritaet: 140,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung: "Erkanntes Potenzial bei einem Kunden bis zur Entscheidung.",
    kennungFeld: null,
    felder: [
      {
        key: "bezeichnung",
        label: "Bezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "geschaeftsbereich",
        label: "Geschäftsbereich",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "akquiseanlass",
        label: "Akquiseanlass",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bedarfsbeschreibung",
        label: "Bedarfsbeschreibung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "saisonfenster",
        label: "Saisonfenster",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "geschaetztesVolumen",
        label: "Geschätztes Volumen",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "verlustgrund",
        label: "Verlustgrund",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "entschiedenAm",
        label: "Entschieden am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Identifiziert", "Qualifiziert", "Gewonnen", "Verloren"],
    actions: [
      {
        name: "Verkaufschance anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Identifiziert",
        erlaubt: [],
        rollen: ["VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Verkaufschance bearbeiten",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Identifiziert", "Qualifiziert"],
        rollen: ["VB"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Verkaufschance zuweisen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Identifiziert", "Qualifiziert"],
        rollen: ["LV"],
        relation: "verkaufschance-zugewiesen-an-mitarbeiter",
        prioritaet: 30,
      },
      {
        name: "Verkaufschance qualifizieren",
        operation: "Setzen",
        art: "Status",
        ziel: "Qualifiziert",
        erlaubt: ["Identifiziert"],
        rollen: ["VB"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Verkaufschance gewinnen",
        operation: "Setzen",
        art: "Status",
        ziel: "Gewonnen",
        erlaubt: ["Qualifiziert"],
        rollen: ["VB"],
        relation: null,
        prioritaet: 60,
      },
      {
        name: "Verkaufschance verlieren",
        operation: "Setzen",
        art: "Status",
        ziel: "Verloren",
        erlaubt: ["Identifiziert", "Qualifiziert"],
        rollen: ["VB"],
        relation: null,
        prioritaet: 70,
      },
    ],
  },
  {
    slug: "kundenkontakt",
    name: "Kundenkontakt",
    plural: "Kundenkontakte",
    art: "Vorgang",
    prioritaet: 150,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Dokumentiertes Gespräch, Telefonat oder Besuch mit einem Kunden.",
    kennungFeld: null,
    felder: [
      {
        key: "datum",
        label: "Datum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "kontaktart",
        label: "Kontaktart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "anlass",
        label: "Anlass",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "ergebnis",
        label: "Ergebnis",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "unterlagen",
        label: "Unterlagen",
        typ: "Datei",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Kundenkontakt dokumentieren",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["VB"],
        relation: null,
        prioritaet: 10,
      },
    ],
  },
  {
    slug: "aufgabe",
    name: "Aufgabe",
    plural: "Aufgaben",
    art: "Vorgang",
    prioritaet: 160,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung: "Wiedervorlage oder Vertriebsaufgabe mit Fälligkeit.",
    kennungFeld: null,
    felder: [
      {
        key: "titel",
        label: "Titel",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "aufgabenart",
        label: "Aufgabenart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "faelligAm",
        label: "Fällig am",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "prioritaet",
        label: "Priorität",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "beschreibung",
        label: "Beschreibung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "ergebnis",
        label: "Ergebnis",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Offen", "Erledigt", "Verworfen"],
    actions: [
      {
        name: "Aufgabe anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Offen",
        erlaubt: [],
        rollen: ["VB", "LV"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Aufgabe zuweisen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Offen"],
        rollen: ["LV"],
        relation: "aufgabe-zugewiesen-an-mitarbeiter",
        prioritaet: 30,
      },
      {
        name: "Aufgabe erledigen",
        operation: "Setzen",
        art: "Status",
        ziel: "Erledigt",
        erlaubt: ["Offen"],
        rollen: ["VB"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Aufgabe verwerfen",
        operation: "Setzen",
        art: "Status",
        ziel: "Verworfen",
        erlaubt: ["Offen"],
        rollen: ["VB", "LV"],
        relation: null,
        prioritaet: 60,
      },
    ],
  },
  {
    slug: "bestellung",
    name: "Bestellung",
    plural: "Bestellungen",
    art: "Vorgang",
    prioritaet: 170,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Eingegangene Kundenbestellung im Baustoffhandel bis zur Klärung.",
    kennungFeld: null,
    felder: [
      {
        key: "eingangsdatum",
        label: "Eingangsdatum",
        typ: "Datum und Uhrzeit",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "eingangskanal",
        label: "Eingangskanal",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bestelldokument",
        label: "Bestelldokument",
        typ: "Datei",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "kundenreferenz",
        label: "Kundenreferenz",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bestellinhalt",
        label: "Bestellinhalt",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "gewuenschterLiefertermin",
        label: "Gewünschter Liefertermin",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "lieferadresse",
        label: "Lieferadresse",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "rueckfragen",
        label: "Rückfragen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Eingegangen", "Geklärt"],
    actions: [
      {
        name: "Bestellung anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Eingegangen",
        erlaubt: [],
        rollen: ["ID"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Bestellung empfangen",
        operation: "Empfangen",
        art: "Extern",
        ziel: "Eingegangen",
        erlaubt: [],
        rollen: ["HA"],
        relation: null,
        prioritaet: 15,
      },
      {
        name: "Bestellung ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Eingegangen"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Bearbeitung übernehmen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Eingegangen"],
        rollen: ["ID"],
        relation: "bestellung-bearbeitet-von-mitarbeiter",
        prioritaet: 30,
      },
      {
        name: "Kunde zuordnen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Eingegangen"],
        rollen: ["ID"],
        relation: "bestellung-von-kunde",
        prioritaet: 30,
      },
      {
        name: "Bestellung klären",
        operation: "Setzen",
        art: "Status",
        ziel: "Geklärt",
        erlaubt: ["Eingegangen"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 50,
      },
    ],
  },
  {
    slug: "auftrag",
    name: "Auftrag",
    plural: "Aufträge",
    art: "Vorgang",
    prioritaet: 180,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Erteilter Kundenauftrag (Dienstleistung oder Handel) bis zum Abschluss.",
    kennungFeld: "auftragsnummer",
    felder: [
      {
        key: "auftragsnummer",
        label: "Auftragsnummer",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "auftragsart",
        label: "Auftragsart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "auftragsdatum",
        label: "Auftragsdatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "kundenreferenz",
        label: "Kundenreferenz",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "auftragsblatt",
        label: "Auftragsblatt",
        typ: "Datei",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "ausfuehrungszeitraumVon",
        label: "Ausführungszeitraum von",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "ausfuehrungszeitraumBis",
        label: "Ausführungszeitraum bis",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "liefertermin",
        label: "Liefertermin",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "lieferadresse",
        label: "Lieferadresse",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "versandart",
        label: "Versandart",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bemerkungen",
        label: "Bemerkungen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "abrechnungsbereitSeit",
        label: "Abrechnungsbereit seit",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Erteilt", "Freigegeben", "Abrechnungsbereit", "Abgeschlossen"],
    actions: [
      {
        name: "Auftrag anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Erteilt",
        erlaubt: [],
        rollen: ["ID", "VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Auftrag ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Erteilt", "Freigegeben"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Auftrag freigeben",
        operation: "Setzen",
        art: "Status",
        ziel: "Freigegeben",
        erlaubt: ["Erteilt"],
        rollen: ["ID", "DI"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Auftrag abrechnungsbereit setzen",
        operation: "Setzen",
        art: "Status",
        ziel: "Abrechnungsbereit",
        erlaubt: ["Freigegeben"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 60,
      },
      {
        name: "Auftrag abschließen",
        operation: "Setzen",
        art: "Status",
        ziel: "Abgeschlossen",
        erlaubt: ["Freigegeben", "Abrechnungsbereit"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 70,
      },
    ],
  },
  {
    slug: "auftragsposition",
    name: "Auftragsposition",
    plural: "Auftragspositionen",
    art: "Beleg",
    prioritaet: 190,
    navigation: "dokumente",
    inNavigation: false,
    mobil: false,
    beschreibung: "Beauftragte Leistung oder Artikel eines Auftrags.",
    kennungFeld: null,
    felder: [
      {
        key: "positionsnummer",
        label: "Positionsnummer",
        typ: "Ganzzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bezeichnung",
        label: "Bezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "menge",
        label: "Menge",
        typ: "Dezimalzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einheit",
        label: "Einheit",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einzelpreis",
        label: "Einzelpreis",
        typ: "Dezimalzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "zusatzleistung",
        label: "Zusatzleistung",
        typ: "Boolean",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Auftragsposition anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["ID", "VB"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Auftragsposition ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["ID"],
        relation: null,
        prioritaet: 20,
      },
    ],
  },
  {
    slug: "lieferung",
    name: "Lieferung",
    plural: "Lieferungen",
    art: "Vorgang",
    prioritaet: 200,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Auslieferung eines Handelsauftrags inkl. Lieferschein und Zustellnachweis.",
    kennungFeld: "lieferscheinnummer",
    felder: [
      {
        key: "lieferscheinnummer",
        label: "Lieferscheinnummer",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "liefertermin",
        label: "Liefertermin",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "versandart",
        label: "Versandart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "anzahlPackstuecke",
        label: "Anzahl Packstücke",
        typ: "Ganzzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "transportdienstleister",
        label: "Transportdienstleister",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "sendungsnummer",
        label: "Sendungsnummer",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "abweichungen",
        label: "Abweichungen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "empfangsquittung",
        label: "Empfangsquittung",
        typ: "Datei",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "empfangenVon",
        label: "Empfangen von",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "angeliefertAm",
        label: "Angeliefert am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Veranlasst", "Bereitgestellt", "Versendet", "Zugestellt"],
    actions: [
      {
        name: "Lieferung veranlassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Veranlasst",
        erlaubt: [],
        rollen: ["ID"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Lieferung ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Veranlasst", "Bereitgestellt"],
        rollen: ["ID", "PM"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Lieferung bereitstellen",
        operation: "Setzen",
        art: "Status",
        ziel: "Bereitgestellt",
        erlaubt: ["Veranlasst"],
        rollen: ["PM"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Transport beauftragen",
        operation: "Senden",
        art: "Extern",
        ziel: null,
        erlaubt: ["Bereitgestellt"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 55,
      },
      {
        name: "Lieferung versenden",
        operation: "Setzen",
        art: "Status",
        ziel: "Versendet",
        erlaubt: ["Bereitgestellt"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 60,
      },
      {
        name: "Zustellung bestätigen",
        operation: "Setzen",
        art: "Status",
        ziel: "Zugestellt",
        erlaubt: ["Versendet"],
        rollen: ["TD"],
        relation: null,
        prioritaet: 70,
      },
    ],
  },
  {
    slug: "rechnung",
    name: "Rechnung",
    plural: "Rechnungen",
    art: "Beleg",
    prioritaet: 210,
    navigation: "dokumente",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "In Bexio erstellte Rechnung zu einem Auftrag inkl. Zahlung und Mahnstand.",
    kennungFeld: "rechnungsnummer",
    felder: [
      {
        key: "rechnungsnummer",
        label: "Rechnungsnummer",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bexioRechnungsnummer",
        label: "Bexio-Rechnungsnummer",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "rechnungsdatum",
        label: "Rechnungsdatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "faelligkeitsdatum",
        label: "Fälligkeitsdatum",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "betragNetto",
        label: "Betrag netto",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "betragBrutto",
        label: "Betrag brutto",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "rechnungsdokument",
        label: "Rechnungsdokument",
        typ: "Datei",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "mahnstufe",
        label: "Mahnstufe",
        typ: "Ganzzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "letzteMahnungAm",
        label: "Letzte Mahnung am",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bezahlterBetrag",
        label: "Bezahlter Betrag",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bezahltAm",
        label: "Bezahlt am",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "versendetAm",
        label: "Versendet am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Erstellt", "Versendet", "Gemahnt", "Bezahlt"],
    actions: [
      {
        name: "Rechnung in Bexio erstellen",
        operation: "Senden",
        art: "Extern",
        ziel: "Erstellt",
        erlaubt: [],
        rollen: ["ID"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Rechnung versenden",
        operation: "Senden",
        art: "Status",
        ziel: "Versendet",
        erlaubt: ["Erstellt"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Rechnung mahnen",
        operation: "Senden",
        art: "Status",
        ziel: "Gemahnt",
        erlaubt: ["Versendet", "Gemahnt"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 60,
      },
      {
        name: "Zahlungseingang übernehmen",
        operation: "Empfangen",
        art: "Extern",
        ziel: null,
        erlaubt: ["Versendet", "Gemahnt"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 65,
      },
      {
        name: "Rechnung als bezahlt kennzeichnen",
        operation: "Setzen",
        art: "Status",
        ziel: "Bezahlt",
        erlaubt: ["Versendet", "Gemahnt"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 70,
      },
    ],
  },
  {
    slug: "fahrzeug",
    name: "Fahrzeug",
    plural: "Fahrzeuge",
    art: "Stammdaten",
    prioritaet: 220,
    navigation: "stammdaten",
    inNavigation: true,
    mobil: false,
    beschreibung: "Fahrzeug oder Maschine für Einsätze und Transporte.",
    kennungFeld: "kennzeichen",
    felder: [
      {
        key: "bezeichnung",
        label: "Bezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "kennzeichen",
        label: "Kennzeichen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "fahrzeugart",
        label: "Fahrzeugart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "stundenkostensatz",
        label: "Stundenkostensatz",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [],
  },
  {
    slug: "abwesenheit",
    name: "Abwesenheit",
    plural: "Abwesenheiten",
    art: "Vorgang",
    prioritaet: 230,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Ferien, Krankheit oder sonstige Abwesenheit eines Mitarbeitenden.",
    kennungFeld: null,
    felder: [
      {
        key: "von",
        label: "Von",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bis",
        label: "Bis",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "abwesenheitsart",
        label: "Abwesenheitsart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "tagesanteil",
        label: "Tagesanteil",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bemerkung",
        label: "Bemerkung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "gemeldetAm",
        label: "Gemeldet am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Gemeldet", "Bestätigt"],
    actions: [
      {
        name: "Abwesenheit melden",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Gemeldet",
        erlaubt: [],
        rollen: ["GF", "SU", "PM"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Abwesenheit erfassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Gemeldet",
        erlaubt: [],
        rollen: ["DI"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Abwesenheit ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Gemeldet", "Bestätigt"],
        rollen: ["DI"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Abwesenheit bestätigen",
        operation: "Setzen",
        art: "Status",
        ziel: "Bestätigt",
        erlaubt: ["Gemeldet"],
        rollen: ["DI"],
        relation: null,
        prioritaet: 50,
      },
    ],
  },
  {
    slug: "einsatz",
    name: "Einsatz",
    plural: "Einsätze",
    art: "Vorgang",
    prioritaet: 240,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: true,
    beschreibung:
      "Geplanter Arbeitsslot (Halbtag) eines Teams für einen Auftrag inkl. Ausführungsprüfung.",
    kennungFeld: null,
    felder: [
      {
        key: "einsatzdatum",
        label: "Einsatzdatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "zeitslot",
        label: "Zeitslot",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einsatzhinweise",
        label: "Einsatzhinweise",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bodentemperatur",
        label: "Bodentemperatur",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "lufttemperatur",
        label: "Lufttemperatur",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "luftfeuchtigkeit",
        label: "Luftfeuchtigkeit",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "oberflaecheTrocken",
        label: "Oberfläche trocken",
        typ: "Boolean",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "oberflaecheSauber",
        label: "Oberfläche sauber",
        typ: "Boolean",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "begruendungAusfuehrungsentscheidung",
        label: "Begründung Ausführungsentscheidung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "geprueftAm",
        label: "Geprüft am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [
      "Geplant",
      "Terminiert",
      "Ausführung freigegeben",
      "Ausgeführt",
      "Ausführung abgesagt",
    ],
    actions: [
      {
        name: "Einsatz planen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Geplant",
        erlaubt: [],
        rollen: ["DI"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Einsatz ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Geplant", "Terminiert"],
        rollen: ["DI"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Team zuordnen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Geplant", "Terminiert"],
        rollen: ["DI"],
        relation: "einsatz-team",
        prioritaet: 30,
      },
      {
        name: "Gruppenführer festlegen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Geplant", "Terminiert"],
        rollen: ["DI"],
        relation: "einsatz-gefuehrt-von-mitarbeiter",
        prioritaet: 30,
      },
      {
        name: "Fahrzeug zuordnen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Geplant", "Terminiert"],
        rollen: ["DI"],
        relation: "einsatz-nutzt-fahrzeug",
        prioritaet: 30,
      },
      {
        name: "Einsatz terminieren",
        operation: "Setzen",
        art: "Status",
        ziel: "Terminiert",
        erlaubt: ["Geplant"],
        rollen: ["DI"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Prüfwerte erfassen",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Terminiert"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 55,
      },
      {
        name: "Ausführung freigeben",
        operation: "Setzen",
        art: "Status",
        ziel: "Ausführung freigegeben",
        erlaubt: ["Terminiert"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 60,
      },
      {
        name: "Einsatz als ausgeführt melden",
        operation: "Setzen",
        art: "Status",
        ziel: "Ausgeführt",
        erlaubt: ["Ausführung freigegeben"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 70,
      },
      {
        name: "Ausführung absagen",
        operation: "Setzen",
        art: "Status",
        ziel: "Ausführung abgesagt",
        erlaubt: ["Terminiert"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 80,
      },
    ],
  },
  {
    slug: "arbeitsrapport",
    name: "Arbeitsrapport",
    plural: "Arbeitsrapporte",
    art: "Beleg",
    prioritaet: 250,
    navigation: "dokumente",
    inNavigation: true,
    mobil: true,
    beschreibung: "Rapport eines Einsatzes mit Ausführungsparametern.",
    kennungFeld: "rapportnummer",
    felder: [
      {
        key: "rapportnummer",
        label: "Rapportnummer",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "rapportdatum",
        label: "Rapportdatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bindemittelDosierung",
        label: "Bindemittel-Dosierung",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "splittDosierung",
        label: "Splitt-Dosierung",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "anpassungen",
        label: "Anpassungen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "anfahrtszeit",
        label: "Anfahrtszeit",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bemerkungen",
        label: "Bemerkungen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["In Erfassung", "Abgeschlossen"],
    actions: [
      {
        name: "Arbeitsrapport anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "In Erfassung",
        erlaubt: [],
        rollen: ["GF"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Arbeitsrapport ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["In Erfassung"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Arbeitsrapport abschließen",
        operation: "Setzen",
        art: "Status",
        ziel: "Abgeschlossen",
        erlaubt: ["In Erfassung"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 50,
      },
    ],
  },
  {
    slug: "rapportzeile",
    name: "Rapportzeile",
    plural: "Rapportzeilen",
    art: "Vorgang",
    prioritaet: 260,
    navigation: "vorgaenge",
    inNavigation: false,
    mobil: true,
    beschreibung:
      "Gemeldete Arbeits-, Fahrzeug- oder Maschinenzeit bzw. Menge zu einem Einsatz.",
    kennungFeld: null,
    felder: [
      {
        key: "zeilenart",
        label: "Zeilenart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "beginn",
        label: "Beginn",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "ende",
        label: "Ende",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "pause",
        label: "Pause",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "stunden",
        label: "Stunden",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "gemeldeteMenge",
        label: "Gemeldete Menge",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bemerkung",
        label: "Bemerkung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Rapportzeile erfassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["GF", "SU"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Rapportzeile ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["GF"],
        relation: null,
        prioritaet: 20,
      },
    ],
  },
  {
    slug: "ausmassprotokoll",
    name: "Ausmaßprotokoll",
    plural: "Ausmaßprotokolle",
    art: "Beleg",
    prioritaet: 270,
    navigation: "dokumente",
    inNavigation: true,
    mobil: false,
    beschreibung:
      "Aufstellung der ausgeführten Mengen eines Auftrags zur Kundenfreigabe.",
    kennungFeld: "protokollnummer",
    felder: [
      {
        key: "protokollnummer",
        label: "Protokollnummer",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "ausmassdatum",
        label: "Ausmaßdatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "bemerkungen",
        label: "Bemerkungen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "korrekturwunsch",
        label: "Korrekturwunsch",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "freigabedokument",
        label: "Freigabedokument",
        typ: "Datei",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "freigegebenAm",
        label: "Freigegeben am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [
      "Erstellt",
      "Zur Prüfung übermittelt",
      "Korrektur verlangt",
      "Freigegeben",
    ],
    actions: [
      {
        name: "Ausmaßprotokoll anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Erstellt",
        erlaubt: [],
        rollen: ["GF"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Ausmaßprotokoll übermitteln",
        operation: "Senden",
        art: "Status",
        ziel: "Zur Prüfung übermittelt",
        erlaubt: ["Erstellt", "Korrektur verlangt"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Ausmaßkorrektur verlangen",
        operation: "Setzen",
        art: "Status",
        ziel: "Korrektur verlangt",
        erlaubt: ["Zur Prüfung übermittelt"],
        rollen: ["KO"],
        relation: null,
        prioritaet: 60,
      },
      {
        name: "Ausmaß freigeben",
        operation: "Setzen",
        art: "Status",
        ziel: "Freigegeben",
        erlaubt: ["Zur Prüfung übermittelt"],
        rollen: ["KO"],
        relation: null,
        prioritaet: 70,
      },
    ],
  },
  {
    slug: "ausmassposition",
    name: "Ausmaßposition",
    plural: "Ausmaßpositionen",
    art: "Beleg",
    prioritaet: 280,
    navigation: "dokumente",
    inNavigation: false,
    mobil: false,
    beschreibung: "Ausgeführte Menge einer Auftragsposition.",
    kennungFeld: null,
    felder: [
      {
        key: "bezeichnung",
        label: "Bezeichnung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "ausgefuehrteMenge",
        label: "Ausgeführte Menge",
        typ: "Dezimalzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einheit",
        label: "Einheit",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "nachweis",
        label: "Nachweis",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: [],
    actions: [
      {
        name: "Ausmaßposition erfassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["GF"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Ausmaßposition ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: [],
        rollen: ["GF"],
        relation: null,
        prioritaet: 20,
      },
    ],
  },
  {
    slug: "materialbewegung",
    name: "Materialbewegung",
    plural: "Materialbewegungen",
    art: "Vorgang",
    prioritaet: 290,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: true,
    beschreibung:
      "Entnahme, Verbrauch, Rückgabe oder Auslieferung eines Artikels.",
    kennungFeld: null,
    felder: [
      {
        key: "bewegungsart",
        label: "Bewegungsart",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "menge",
        label: "Menge",
        typ: "Dezimalzahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "einheit",
        label: "Einheit",
        typ: "Auswahl",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "zeitpunkt",
        label: "Zeitpunkt",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bemerkung",
        label: "Bemerkung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Gemeldet", "Bestätigt"],
    actions: [
      {
        name: "Materialbewegung erfassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Gemeldet",
        erlaubt: [],
        rollen: ["GF", "SU", "PM"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Materialbewegung ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Gemeldet"],
        rollen: ["PM"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Materialbewegung Auftrag zuordnen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Gemeldet"],
        rollen: ["PM"],
        relation: "materialbewegung-fuer-auftrag",
        prioritaet: 30,
      },
      {
        name: "Materialbewegung bestätigen",
        operation: "Setzen",
        art: "Status",
        ziel: "Bestätigt",
        erlaubt: ["Gemeldet"],
        rollen: ["PM"],
        relation: null,
        prioritaet: 50,
      },
    ],
  },
  {
    slug: "nachkalkulation",
    name: "Nachkalkulation",
    plural: "Nachkalkulationen",
    art: "Vorgang",
    prioritaet: 300,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung: "Ergebnisrechnung eines abgeschlossenen Auftrags.",
    kennungFeld: null,
    felder: [
      {
        key: "stichtag",
        label: "Stichtag",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "sonstigeKosten",
        label: "Sonstige Kosten",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "beurteilung",
        label: "Beurteilung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "abweichungsursachen",
        label: "Abweichungsursachen",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "konsequenzenFuerAngebote",
        label: "Konsequenzen für Angebote",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "bewertetAm",
        label: "Bewertet am",
        typ: "Datum und Uhrzeit",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["In Erstellung", "Bewertet"],
    actions: [
      {
        name: "Nachkalkulation anlegen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "In Erstellung",
        erlaubt: [],
        rollen: ["ID"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Nachkalkulation ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["In Erstellung"],
        rollen: ["ID", "LV"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Nachkalkulation bewerten",
        operation: "Setzen",
        art: "Status",
        ziel: "Bewertet",
        erlaubt: ["In Erstellung"],
        rollen: ["LV"],
        relation: null,
        prioritaet: 50,
      },
    ],
  },
  {
    slug: "reklamation",
    name: "Reklamation",
    plural: "Reklamationen",
    art: "Vorgang",
    prioritaet: 310,
    navigation: "vorgaenge",
    inNavigation: true,
    mobil: false,
    beschreibung: "Mangelmeldung eines Kunden zu einer erbrachten Leistung.",
    kennungFeld: null,
    felder: [
      {
        key: "eingangsdatum",
        label: "Eingangsdatum",
        typ: "Datum",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "meldekanal",
        label: "Meldekanal",
        typ: "Auswahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "mangelbeschreibung",
        label: "Mangelbeschreibung",
        typ: "Text",
        pflicht: true,
        mehrfach: false,
      },
      {
        key: "beurteilung",
        label: "Beurteilung",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "ablehnungsgrund",
        label: "Ablehnungsgrund",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "nacharbeitsaufwand",
        label: "Nacharbeitsaufwand",
        typ: "Dezimalzahl",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "erledigungsvermerk",
        label: "Erledigungsvermerk",
        typ: "Text",
        pflicht: false,
        mehrfach: false,
      },
      {
        key: "kundeInformiertAm",
        label: "Kunde informiert am",
        typ: "Datum",
        pflicht: false,
        mehrfach: false,
      },
    ],
    zustaende: ["Gemeldet", "Behoben", "Abgelehnt", "Abgeschlossen"],
    actions: [
      {
        name: "Reklamation erfassen",
        operation: "Anlegen",
        art: "Daten",
        ziel: "Gemeldet",
        erlaubt: [],
        rollen: ["ID", "KO"],
        relation: null,
        prioritaet: 10,
      },
      {
        name: "Reklamation ändern",
        operation: "Ändern",
        art: "Daten",
        ziel: null,
        erlaubt: ["Gemeldet", "Behoben", "Abgelehnt"],
        rollen: ["GF", "ID"],
        relation: null,
        prioritaet: 20,
      },
      {
        name: "Reklamation Auftrag zuordnen",
        operation: "Aufbauen",
        art: "Beziehung",
        ziel: null,
        erlaubt: ["Gemeldet"],
        rollen: ["GF", "ID"],
        relation: "reklamation-zu-auftrag",
        prioritaet: 30,
      },
      {
        name: "Mangel als behoben melden",
        operation: "Setzen",
        art: "Status",
        ziel: "Behoben",
        erlaubt: ["Gemeldet"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 50,
      },
      {
        name: "Reklamation ablehnen",
        operation: "Setzen",
        art: "Status",
        ziel: "Abgelehnt",
        erlaubt: ["Gemeldet"],
        rollen: ["GF"],
        relation: null,
        prioritaet: 60,
      },
      {
        name: "Reklamation abschließen",
        operation: "Setzen",
        art: "Status",
        ziel: "Abgeschlossen",
        erlaubt: ["Behoben", "Abgelehnt"],
        rollen: ["ID"],
        relation: null,
        prioritaet: 70,
      },
    ],
  },
];

export const RELATIONEN: Relation[] = [
  {
    id: "abwesenheit-betrifft-mitarbeiter",
    name: "Abwesenheit betrifft Mitarbeiter",
    label: "betrifft Mitarbeiter",
    von: "abwesenheit",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "angebot-an-ansprechpartner",
    name: "Angebot an Ansprechpartner",
    label: "an Ansprechpartner",
    von: "angebot",
    zu: "ansprechpartner",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "angebot-an-kunde",
    name: "Angebot an Kunde",
    label: "an Kunde",
    von: "angebot",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "angebot-erstellt-von-mitarbeiter",
    name: "Angebot erstellt von Mitarbeiter",
    label: "erstellt von Mitarbeiter",
    von: "angebot",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "angebot-zu-verkaufschance",
    name: "Angebot zu Verkaufschance",
    label: "zu Verkaufschance",
    von: "angebot",
    zu: "verkaufschance",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "angebot-basiert-auf-kalkulation",
    name: "Angebot basiert auf Kalkulation",
    label: "basiert auf Kalkulation",
    von: "angebot",
    zu: "kalkulation",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
  {
    id: "angebot-betrifft-strassenobjekt",
    name: "Angebot betrifft Straßenobjekt",
    label: "betrifft Straßenobjekt",
    von: "angebot",
    zu: "strassenobjekt",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
  {
    id: "angebot-ersetzt-angebot",
    name: "Angebot ersetzt Angebot",
    label: "ersetzt Angebot",
    von: "angebot",
    zu: "angebot",
    kardinalitaetVon: "01",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "angebot-zu-bestellung",
    name: "Angebot zu Bestellung",
    label: "zu Bestellung",
    von: "angebot",
    zu: "bestellung",
    kardinalitaetVon: "01",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "angebotsposition-gehoert-zu-angebot",
    name: "Angebotsposition gehört zu Angebot",
    label: "gehört zu Angebot",
    von: "angebotsposition",
    zu: "angebot",
    kardinalitaetVon: "1n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "angebotsposition-bietet-an-artikel",
    name: "Angebotsposition bietet an Artikel",
    label: "bietet an Artikel",
    von: "angebotsposition",
    zu: "artikel",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "angebotsposition-bietet-an-massnahmenart",
    name: "Angebotsposition bietet an Maßnahmenart",
    label: "bietet an Maßnahmenart",
    von: "angebotsposition",
    zu: "massnahmenart",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "ansprechpartner-gehoert-zu-kunde",
    name: "Ansprechpartner gehört zu Kunde",
    label: "gehört zu Kunde",
    von: "ansprechpartner",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "arbeitsrapport-zu-einsatz",
    name: "Arbeitsrapport zu Einsatz",
    label: "zu Einsatz",
    von: "arbeitsrapport",
    zu: "einsatz",
    kardinalitaetVon: "01",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "aufgabe-zugewiesen-an-mitarbeiter",
    name: "Aufgabe zugewiesen an Mitarbeiter",
    label: "zugewiesen an Mitarbeiter",
    von: "aufgabe",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "aufgabe-betrifft-kunde",
    name: "Aufgabe betrifft Kunde",
    label: "betrifft Kunde",
    von: "aufgabe",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "aufgabe-betrifft-angebot",
    name: "Aufgabe betrifft Angebot",
    label: "betrifft Angebot",
    von: "aufgabe",
    zu: "angebot",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "aufgabe-betrifft-verkaufschance",
    name: "Aufgabe betrifft Verkaufschance",
    label: "betrifft Verkaufschance",
    von: "aufgabe",
    zu: "verkaufschance",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "auftrag-von-kunde",
    name: "Auftrag von Kunde",
    label: "von Kunde",
    von: "auftrag",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "auftrag-ansprechpartner",
    name: "Auftrag Ansprechpartner",
    label: "Ansprechpartner",
    von: "auftrag",
    zu: "ansprechpartner",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "auftrag-betrifft-strassenobjekt",
    name: "Auftrag betrifft Straßenobjekt",
    label: "betrifft Straßenobjekt",
    von: "auftrag",
    zu: "strassenobjekt",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
  {
    id: "auftrag-aus-angebot",
    name: "Auftrag aus Angebot",
    label: "aus Angebot",
    von: "auftrag",
    zu: "angebot",
    kardinalitaetVon: "01",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "auftrag-aus-bestellung",
    name: "Auftrag aus Bestellung",
    label: "aus Bestellung",
    von: "auftrag",
    zu: "bestellung",
    kardinalitaetVon: "01",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "auftragsposition-gehoert-zu-auftrag",
    name: "Auftragsposition gehört zu Auftrag",
    label: "gehört zu Auftrag",
    von: "auftragsposition",
    zu: "auftrag",
    kardinalitaetVon: "1n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "auftragsposition-umfasst-artikel",
    name: "Auftragsposition umfasst Artikel",
    label: "umfasst Artikel",
    von: "auftragsposition",
    zu: "artikel",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "auftragsposition-umfasst-massnahmenart",
    name: "Auftragsposition umfasst Maßnahmenart",
    label: "umfasst Maßnahmenart",
    von: "auftragsposition",
    zu: "massnahmenart",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "auftragsposition-uebernimmt-angebotsposition",
    name: "Auftragsposition übernimmt Angebotsposition",
    label: "übernimmt Angebotsposition",
    von: "auftragsposition",
    zu: "angebotsposition",
    kardinalitaetVon: "01",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "ausmassposition-gehoert-zu-ausmassprotokoll",
    name: "Ausmaßposition gehört zu Ausmaßprotokoll",
    label: "gehört zu Ausmaßprotokoll",
    von: "ausmassposition",
    zu: "ausmassprotokoll",
    kardinalitaetVon: "1n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "ausmassposition-misst-auftragsposition",
    name: "Ausmaßposition misst Auftragsposition",
    label: "misst Auftragsposition",
    von: "ausmassposition",
    zu: "auftragsposition",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "ausmassprotokoll-zu-auftrag",
    name: "Ausmaßprotokoll zu Auftrag",
    label: "zu Auftrag",
    von: "ausmassprotokoll",
    zu: "auftrag",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "baustellenaufnahme-erstellt-von-mitarbeiter",
    name: "Baustellenaufnahme erstellt von Mitarbeiter",
    label: "erstellt von Mitarbeiter",
    von: "baustellenaufnahme",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "baustellenaufnahme-betrifft-strassenobjekt",
    name: "Baustellenaufnahme betrifft Straßenobjekt",
    label: "betrifft Straßenobjekt",
    von: "baustellenaufnahme",
    zu: "strassenobjekt",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "baustellenaufnahme-fuer-verkaufschance",
    name: "Baustellenaufnahme für Verkaufschance",
    label: "für Verkaufschance",
    von: "baustellenaufnahme",
    zu: "verkaufschance",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "baustellenfoto-gehoert-zu-baustellenaufnahme",
    name: "Baustellenfoto gehört zu Baustellenaufnahme",
    label: "gehört zu Baustellenaufnahme",
    von: "baustellenfoto",
    zu: "baustellenaufnahme",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "baustellenfoto-belegt-ausmassposition",
    name: "Baustellenfoto belegt Ausmaßposition",
    label: "belegt Ausmaßposition",
    von: "baustellenfoto",
    zu: "ausmassposition",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
  {
    id: "baustellenfoto-dokumentiert-einsatz",
    name: "Baustellenfoto dokumentiert Einsatz",
    label: "dokumentiert Einsatz",
    von: "baustellenfoto",
    zu: "einsatz",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "baustellenfoto-belegt-reklamation",
    name: "Baustellenfoto belegt Reklamation",
    label: "belegt Reklamation",
    von: "baustellenfoto",
    zu: "reklamation",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "baustellenfoto-zeigt-schadstelle",
    name: "Baustellenfoto zeigt Schadstelle",
    label: "zeigt Schadstelle",
    von: "baustellenfoto",
    zu: "schadstelle",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "bestellung-bestellt-durch-ansprechpartner",
    name: "Bestellung bestellt durch Ansprechpartner",
    label: "bestellt durch Ansprechpartner",
    von: "bestellung",
    zu: "ansprechpartner",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "bestellung-von-kunde",
    name: "Bestellung von Kunde",
    label: "von Kunde",
    von: "bestellung",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "bestellung-bearbeitet-von-mitarbeiter",
    name: "Bestellung bearbeitet von Mitarbeiter",
    label: "bearbeitet von Mitarbeiter",
    von: "bestellung",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "bestellung-bestellt-artikel",
    name: "Bestellung bestellt Artikel",
    label: "bestellt Artikel",
    von: "bestellung",
    zu: "artikel",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
  {
    id: "einsatz-fuer-auftrag",
    name: "Einsatz für Auftrag",
    label: "für Auftrag",
    von: "einsatz",
    zu: "auftrag",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "einsatz-am-strassenobjekt",
    name: "Einsatz am Straßenobjekt",
    label: "am Straßenobjekt",
    von: "einsatz",
    zu: "strassenobjekt",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "einsatz-nutzt-fahrzeug",
    name: "Einsatz nutzt Fahrzeug",
    label: "nutzt Fahrzeug",
    von: "einsatz",
    zu: "fahrzeug",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
  {
    id: "einsatz-team",
    name: "Einsatz Team",
    label: "Team",
    von: "einsatz",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
  {
    id: "einsatz-gefuehrt-von-mitarbeiter",
    name: "Einsatz geführt von Mitarbeiter",
    label: "geführt von Mitarbeiter",
    von: "einsatz",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "kalkulation-basiert-auf-baustellenaufnahme",
    name: "Kalkulation basiert auf Baustellenaufnahme",
    label: "basiert auf Baustellenaufnahme",
    von: "kalkulation",
    zu: "baustellenaufnahme",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "kalkulation-fuer-verkaufschance",
    name: "Kalkulation für Verkaufschance",
    label: "für Verkaufschance",
    von: "kalkulation",
    zu: "verkaufschance",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "kalkulation-ersetzt-kalkulation",
    name: "Kalkulation ersetzt Kalkulation",
    label: "ersetzt Kalkulation",
    von: "kalkulation",
    zu: "kalkulation",
    kardinalitaetVon: "01",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "kalkulation-fuer-auftrag",
    name: "Kalkulation für Auftrag",
    label: "für Auftrag",
    von: "kalkulation",
    zu: "auftrag",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "kalkulation-fuer-massnahmenart",
    name: "Kalkulation für Maßnahmenart",
    label: "für Maßnahmenart",
    von: "kalkulation",
    zu: "massnahmenart",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "kalkulationsposition-verwendet-artikel",
    name: "Kalkulationsposition verwendet Artikel",
    label: "verwendet Artikel",
    von: "kalkulationsposition",
    zu: "artikel",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "kalkulationsposition-gehoert-zu-kalkulation",
    name: "Kalkulationsposition gehört zu Kalkulation",
    label: "gehört zu Kalkulation",
    von: "kalkulationsposition",
    zu: "kalkulation",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "kunde-wird-betreut-von-mitarbeiter",
    name: "Kunde wird betreut von Mitarbeiter",
    label: "wird betreut von Mitarbeiter",
    von: "kunde",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "kundenkontakt-gefuehrt-von-mitarbeiter",
    name: "Kundenkontakt geführt von Mitarbeiter",
    label: "geführt von Mitarbeiter",
    von: "kundenkontakt",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "kundenkontakt-betrifft-kunde",
    name: "Kundenkontakt betrifft Kunde",
    label: "betrifft Kunde",
    von: "kundenkontakt",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "kundenkontakt-mit-ansprechpartner",
    name: "Kundenkontakt mit Ansprechpartner",
    label: "mit Ansprechpartner",
    von: "kundenkontakt",
    zu: "ansprechpartner",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "kundenkontakt-betrifft-verkaufschance",
    name: "Kundenkontakt betrifft Verkaufschance",
    label: "betrifft Verkaufschance",
    von: "kundenkontakt",
    zu: "verkaufschance",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "lieferung-zu-auftrag",
    name: "Lieferung zu Auftrag",
    label: "zu Auftrag",
    von: "lieferung",
    zu: "auftrag",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "materialbewegung-betrifft-artikel",
    name: "Materialbewegung betrifft Artikel",
    label: "betrifft Artikel",
    von: "materialbewegung",
    zu: "artikel",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "materialbewegung-fuer-einsatz",
    name: "Materialbewegung für Einsatz",
    label: "für Einsatz",
    von: "materialbewegung",
    zu: "einsatz",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "materialbewegung-fuer-lieferung",
    name: "Materialbewegung für Lieferung",
    label: "für Lieferung",
    von: "materialbewegung",
    zu: "lieferung",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "materialbewegung-fuer-auftrag",
    name: "Materialbewegung für Auftrag",
    label: "für Auftrag",
    von: "materialbewegung",
    zu: "auftrag",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "materialbewegung-gemeldet-von-mitarbeiter",
    name: "Materialbewegung gemeldet von Mitarbeiter",
    label: "gemeldet von Mitarbeiter",
    von: "materialbewegung",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "nachkalkulation-zu-auftrag",
    name: "Nachkalkulation zu Auftrag",
    label: "zu Auftrag",
    von: "nachkalkulation",
    zu: "auftrag",
    kardinalitaetVon: "01",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "rapportzeile-zu-einsatz",
    name: "Rapportzeile zu Einsatz",
    label: "zu Einsatz",
    von: "rapportzeile",
    zu: "einsatz",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "rapportzeile-fuer-fahrzeug",
    name: "Rapportzeile für Fahrzeug",
    label: "für Fahrzeug",
    von: "rapportzeile",
    zu: "fahrzeug",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "rapportzeile-gehoert-zu-arbeitsrapport",
    name: "Rapportzeile gehört zu Arbeitsrapport",
    label: "gehört zu Arbeitsrapport",
    von: "rapportzeile",
    zu: "arbeitsrapport",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "rapportzeile-von-mitarbeiter",
    name: "Rapportzeile von Mitarbeiter",
    label: "von Mitarbeiter",
    von: "rapportzeile",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "rechnung-zu-auftrag",
    name: "Rechnung zu Auftrag",
    label: "zu Auftrag",
    von: "rechnung",
    zu: "auftrag",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "rechnung-an-kunde",
    name: "Rechnung an Kunde",
    label: "an Kunde",
    von: "rechnung",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "reklamation-von-kunde",
    name: "Reklamation von Kunde",
    label: "von Kunde",
    von: "reklamation",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "reklamation-betrifft-strassenobjekt",
    name: "Reklamation betrifft Straßenobjekt",
    label: "betrifft Straßenobjekt",
    von: "reklamation",
    zu: "strassenobjekt",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "reklamation-bearbeitet-von-mitarbeiter",
    name: "Reklamation bearbeitet von Mitarbeiter",
    label: "bearbeitet von Mitarbeiter",
    von: "reklamation",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "reklamation-zu-auftrag",
    name: "Reklamation zu Auftrag",
    label: "zu Auftrag",
    von: "reklamation",
    zu: "auftrag",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "schadstelle-gehoert-zu-baustellenaufnahme",
    name: "Schadstelle gehört zu Baustellenaufnahme",
    label: "gehört zu Baustellenaufnahme",
    von: "schadstelle",
    zu: "baustellenaufnahme",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "schadstelle-empfiehlt-artikel",
    name: "Schadstelle empfiehlt Artikel",
    label: "empfiehlt Artikel",
    von: "schadstelle",
    zu: "artikel",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
  {
    id: "schadstelle-erfordert-massnahmenart",
    name: "Schadstelle erfordert Maßnahmenart",
    label: "erfordert Maßnahmenart",
    von: "schadstelle",
    zu: "massnahmenart",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "strassenobjekt-gehoert-zu-kunde",
    name: "Straßenobjekt gehört zu Kunde",
    label: "gehört zu Kunde",
    von: "strassenobjekt",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "verkaufschance-betrifft-kunde",
    name: "Verkaufschance betrifft Kunde",
    label: "betrifft Kunde",
    von: "verkaufschance",
    zu: "kunde",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "1",
    zuViele: false,
  },
  {
    id: "verkaufschance-zugewiesen-an-mitarbeiter",
    name: "Verkaufschance zugewiesen an Mitarbeiter",
    label: "zugewiesen an Mitarbeiter",
    von: "verkaufschance",
    zu: "mitarbeiter",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "01",
    zuViele: false,
  },
  {
    id: "verkaufschance-betrifft-strassenobjekt",
    name: "Verkaufschance betrifft Straßenobjekt",
    label: "betrifft Straßenobjekt",
    von: "verkaufschance",
    zu: "strassenobjekt",
    kardinalitaetVon: "0n",
    kardinalitaetZu: "0n",
    zuViele: true,
  },
];

export const ROLLEN: Rolle[] = [
  {
    kuerzel: "VB",
    name: "Verkaufsberater (Außendienst)",
    intern: true,
    persona: "m1",
  },
  {
    kuerzel: "LV",
    name: "Leiter Vertrieb",
    intern: true,
    persona: "m2",
  },
  {
    kuerzel: "ID",
    name: "Kaufmännischer Mitarbeiter (Innendienst)",
    intern: true,
    persona: "m7",
  },
  {
    kuerzel: "DI",
    name: "Disponent",
    intern: true,
    persona: "m3",
  },
  {
    kuerzel: "GF",
    name: "Gruppenführer",
    intern: true,
    persona: "m4",
  },
  {
    kuerzel: "SU",
    name: "Straßenunterhaltsmitarbeiter",
    intern: true,
    persona: "m5",
  },
  {
    kuerzel: "PM",
    name: "Produktionsmitarbeiter",
    intern: true,
    persona: "m8",
  },
  {
    kuerzel: "KO",
    name: "Kunde (Kommune)",
    intern: false,
    persona: null,
  },
  {
    kuerzel: "HA",
    name: "Händler / Zentraleinkäufer",
    intern: false,
    persona: null,
  },
  {
    kuerzel: "TD",
    name: "Transportdienstleister (Spedition/KEP)",
    intern: false,
    persona: null,
  },
];
